import React from "react";
import useFetchData from "../../../hooks/useFetchData";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";

const EditFieldMasterData = ({ editFieldData, setEditFieldData }) => {
  const handleDataChange = (value) => {
    const newObj = JSON.parse(JSON.stringify(editFieldData));
    newObj["master_data"] = value;
    setEditFieldData(newObj);
  };

  return (
    <MasterDataSelections
      selectedMasterData={editFieldData.master_data || ""}
      onChange={handleDataChange}
      selectedTypes={["grid"]}
    />
  );
};

export default EditFieldMasterData;

const MasterDataSelections = ({ selectedMasterData, onChange, selectedTypes = [], label = "Select Master Data" }) => {
  const { data, loading, error } = useFetchData("/masterdata");
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Something went wrong</div>;
  let allMasterData = data || [];
  if (selectedTypes.length > 0) {
    allMasterData = allMasterData.filter((master) => selectedTypes.includes(master.type));
  }
  return (
    <div className="builder_form">
      <SingleSelectBox
        selectedData={selectedMasterData}
        options={allMasterData}
        onChange={(obj) => onChange(obj.id)}
        label={label}
        placeholder={label}
      />
    </div>
  );
};

export { MasterDataSelections };
